import React from 'react';
import { useSelector } from 'react-redux';
import { urlMap, urlConstructor } from 'routes/urlMap';
import { getUser } from 'selectors';
import { faUserGear } from '@fortawesome/pro-regular-svg-icons';
import getText from 'context/language/getText';
import { NavGroup } from '../components';

export const SettingsLink = () => {
  const user = useSelector(getUser);
  const settingsLinks = [{
    textPath: 'navbar.settings.myInfo',
    url: urlConstructor(urlMap.MY_INFO, { id: user.id }),
    displayPath: `/employers/${user.id}`,
    name: 'my-info'
  }, {
    textPath: 'navbar.settings.company',
    url: urlConstructor(urlMap.COMPANY_PAGE, {
      id: user.customer.id,
    }),
    displayPath: `/customers/${user.customer.id}`,
    name: 'company'
  }, {
    textPath: 'navbar.settings.preferences',
    url: urlConstructor(urlMap.NOTIFICATION_PREFERENCES),
    displayPath: `/employers/${user.id}/channel_settings`,
    name: 'preferences'
  }];

  return (
    <NavGroup
      links={settingsLinks}
      label={getText('navbar.settings.title')}
      icon={faUserGear}
      name="account"
    />
  );
};
